import { gql } from "lib/apolloClient";

export const controlParameterFragment = {
  controlParameter: gql`
    fragment controlParameterItem on ACLPermission {
      id
      uid
      label
      description
      globalLevel
      viewMetadata
      applicableCurriculumPrograms {
        id
        label
        acronym
      }
      value(roleId: $roleId)
      module {
        id
        uid
        label
        icon
        addonEnabledCurriculumPrograms {
          id
          label
          acronym
        }
      }
    }
  `,
};
